import CreateNewHomeCat from './CreateNewHomeCat';

export default CreateNewHomeCat;
